import { render, staticRenderFns } from "./VerticalTabs.vue?vue&type=template&id=bbb7bc46&scoped=true&"
import script from "./VerticalTabs.vue?vue&type=script&lang=js&"
export * from "./VerticalTabs.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTabs.vue?vue&type=style&index=0&id=bbb7bc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb7bc46",
  null
  
)

export default component.exports